import React from 'react';
import ReactDOM from 'react-dom/client';

/* Self-hosted web fonts. These were previously pulled in render-blocking from
 * fonts.googleapis.com via `@import url(...)` at the top of several component
 * stylesheets, which created a request chain (html -> main.css -> Google CSS
 * -> gstatic woff2) with no preconnect. Serving them from our own origin
 * removes both third-party connections. Only the weights the site actually
 * uses are imported, latin subset only, each with `font-display: swap`.
 *   Poppins    - global body + all headings (App.css --font-body, h1-h6)
 *   Inter      - homepage hero (Hero.css)
 *   Montserrat - course pages (/beginners, /intermediate, /advanced) */
import '@fontsource/poppins/latin-300.css';
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-800.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Routes that were prerendered at build time (see scripts/prerender.js) ship
// real HTML inside #root, so we hydrate them instead of throwing that markup
// away. Every other route serves an empty #root and renders normally.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
